import { REGISTER_SOCKET } from './actions'

export const socket = (state = null, action) => {
    switch (action.type) {
        case REGISTER_SOCKET:
            return action.socket

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/socket/index.js